import { ReactNode } from 'react';
import { Theme, SxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Panel } from '@components/panel/Panel';
import { PanelHeader } from '@components/quotePanel/PanelHeader';
import { icon, getPanelColor, PanelStatus } from '@components/quotePanel/QuotePanel.constants';
import { IMenuItem } from '@components/menu';

export interface IQuotePanel {
  actionContent?: ReactNode;
  allowEdit?: boolean;
  children: ReactNode;
  handleMinimized?: () => void;
  headerActions?: ReactNode;
  helpText?: string | null;
  isMinimized?: boolean;
  menuContent?: ReactNode;
  menuItems?: IMenuItem[];
  onEdit?: () => void;
  showMinimizeButton?: boolean;
  status?: PanelStatus;
  sx?: SxProps;
  title: string;
  hasUnsavedFields?: boolean;
}

export const QuotePanel = ({
  actionContent,
  allowEdit,
  children,
  handleMinimized,
  headerActions,
  helpText,
  isMinimized,
  menuContent,
  menuItems,
  onEdit,
  showMinimizeButton = true,
  status,
  sx,
  title,
  hasUnsavedFields = false,
}: IQuotePanel) => {
  const isPanelSaved = !hasUnsavedFields;
  const { palette } = useTheme<Theme>();
  const color = status && getPanelColor(palette)[status];

  return (
    <Panel panelColor={color?.panel} sx={sx}>
      <PanelHeader
        color={color?.icon}
        minimizedEnabled={isPanelSaved && (status === PanelStatus.Valid || status === PanelStatus.Complete)}
        title={title}
        icon={status && icon[status]}
        headerActions={headerActions}
        actionContent={actionContent}
        menuContent={menuContent}
        menuItems={menuItems}
        helpText={helpText}
        allowEdit={allowEdit}
        onEdit={onEdit}
        showMinimizeButton={showMinimizeButton}
        isMinimized={isMinimized}
        handleMinimized={handleMinimized}
      />
      {children}
    </Panel>
  );
};
